module.exports = __webpack_public_path__ + "img/4.444a2cae.png";